<span>{{lowestPrice >= 0.01 ? (lowestPrice | currency) : 'Free'}}</span>
<span *ngIf="highestPrice > lowestPrice"> - {{(highestPrice | currency)}}</span>
